<div *ngIf="(user)" class="profile">
  <button mat-button [matMenuTriggerFor]="menu" class="user-name-button" id="username">
    <mat-icon class="avatar-icon">account_circle</mat-icon>
    <!-- <img class="avatar-img" src="assets/image/avatar.png" alt="Avatar"> -->
    <span class="display-user-name">{{displayName}}</span>
    <span *appIfDebugFlag="'impersonate_user'" matTooltip="Impersonating user: {{impersonatingTooltip}}">😎</span>
    <mat-icon class="display-drop-down">arrow_drop_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
    <button mat-menu-item *ngFor="let menuItem of additionalMenuItems" (click)="menuItem.buttonAction()">
      {{menuItem.buttonName}}
    </button>
    <button mat-menu-item *appIfFeatureAsync="debugFlag" (click)="showDebugFlags()">Debug Flags</button>
    <button mat-menu-item (click)="requestNewUser()">Request New User</button>
    <button mat-menu-item *ngIf="production" (click)="reportIssue()">Report An Issue</button>
    <button mat-menu-item (click)="logout.emit()">Logout</button>
  </mat-menu>
</div>
